import type { TabViewNavProps } from "./tab-view-nav.type";

import { Tabs } from "antd";

import { useTabViewNav } from "./tab-view-nav.hook";

export const TabViewNav = (props: TabViewNavProps) => {
  const { key, ...tabsProps } = useTabViewNav(props);

  return <Tabs key={key} {...tabsProps} />;
};
